import React from 'react';
import { Repeat, Clock } from 'lucide-react';

interface RecurrenceInfo {
  isRecurring: boolean;
  description: string;
  nextDueDates: string[];
}

interface RecurrenceBadgeProps {
  recurrenceInfo: RecurrenceInfo;
  size?: 'sm' | 'md' | 'lg';
  showDescription?: boolean;
}

const RecurrenceBadge: React.FC<RecurrenceBadgeProps> = ({
  recurrenceInfo,
  size = 'sm',
  showDescription = false
}) => {
  const { isRecurring, description } = recurrenceInfo;

  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  if (!isRecurring) {
    return (
      <span className={`inline-flex items-center ${sizeClasses[size]} bg-gray-100 text-gray-700 rounded-full font-medium`}>
        <Clock className={`${iconSizes[size]} mr-1`} />
        One-time
      </span>
    );
  }

  return (
    <div className="flex items-center space-x-2">
      <span className={`inline-flex items-center ${sizeClasses[size]} bg-blue-100 text-blue-700 rounded-full font-medium`}>
        <Repeat className={`${iconSizes[size]} mr-1`} />
        Recurring
      </span>
      {showDescription && (
        <span className="text-xs text-gray-500">
          {description}
        </span>
      )}
    </div>
  );
};

export { RecurrenceBadge };
export default RecurrenceBadge;
